import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

export interface InputProps
	extends
		React.InputHTMLAttributes<HTMLInputElement>,
		VariantProps<typeof inputVariants> {}

export const inputVariants = cva(
	[
		'flex w-full border px-4 text-base transition-colors aria-invalid:border-destructive',
		'focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring/30 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:text-muted-foreground',
		'placeholder:text-foreground/50 placeholder:text-sm',
		'file:border-0 file:bg-transparent file:font-medium file:text-sm',
		'file:inline-flex file:h-6 file:border-0 file:bg-transparent file:font-medium file:text-foreground file:text-sm',
	],
	{
		defaultVariants: {
			inputSize: 'default',
			variant: 'default',
		},
		variants: {
			inputSize: {
				default: 'h-[40px] rounded-lg text-base',
				sm: 'h-[32px] rounded text-sm',
			},
			variant: {
				default: 'border bg-transparent',
				noBorder: 'border-transparent bg-card text-card-foreground shadow-xs',
				primary: 'border-primary bg-transparent',
			},
		},
	},
)

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, variant, inputSize, type, ...props }, ref) => (
		<input
			className={inputVariants({ className, inputSize, variant })}
			ref={ref}
			type={type}
			{...props}
		/>
	),
)

Input.displayName = 'Input'

export { Input }
